module.exports = __webpack_public_path__ + "static/007007-3506b1d7314be090b5a2c386b242d8c4.jpg";